import { getBlogPosts } from '@/core/components/blog/blogQueryOptions'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const blogSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z.enum(['title', 'author', 'date']).catch('title'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute('/_layout/dashboard/blog/')({
  validateSearch: (search) => blogSearchSchema.parse(search),
  loader: ({ context: { queryClient, auth } }) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    queryClient.ensureQueryData(getBlogPosts(auth.token as string))
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
